import React, { useContext, useState } from 'react'
import banner from '../../../assets/me/kiron.jpg';
import bannerBlur from '../../../assets/me/kiron-blur.jpg';
import { SiBuymeacoffee } from 'react-icons/si';
import { BiLogoFacebook, BiLogoLinkedin } from 'react-icons/bi';
import { FiGithub } from 'react-icons/fi';
import Typewriter from 'typewriter-effect';
import { InitializeContext } from '../../../App';
import { Link } from 'react-scroll';
import { PiHandWavingBold } from 'react-icons/pi';

const Fade = require("react-reveal/Fade");

export default function Banner() {
  const { theme } = useContext(InitializeContext);
  const [loaded, setLoaded] = useState<boolean>(false);

  const typewriterOptions = {
    strings: ['Full-stack Developer', 'Musician', 'Coffee Lover'],
    autoStart: true,
    loop: true,
  }

  return (
    <section id={'home'} className={`md:py-20 pb-10 md:pb-5 ${theme ? 'text-white bg-[#212428]' : 'bg-[#ECF0F3] text-black'}`}>
      <div className="hero">
        <div className="hero-content flex-col justify-between lg:flex-row-reverse">
          <Fade bottom distance="20px">
            <div className='flex justify-center items-center gap-3 md:gap-8 w-full md:w-2/3 lg:w-1/3'>
              <div className='flex lg:hidden flex-col justify-start items-center gap-4'>
                <a href='https://www.facebook.com/toufiqhasankiron' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                  <BiLogoFacebook className='text-md md:text-xl' />
                </a>
                <a href='https://www.linkedin.com/in/toufiq-hasan-kiron' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                  <BiLogoLinkedin className='text-md md:text-xl' />
                </a>
                <a href='https://www.github.com/kiron0' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                  <FiGithub className='text-md md:text-xl' />
                </a>
                <a href='https://www.buymeacoffee.com/_thk' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl group ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary bg-warning border-warning glass'} duration-500`}>
                  <SiBuymeacoffee className={`text-md md:text-xl duration-500 ${theme ? 'group-hover:text-white' : 'text-black group-hover:text-white'}`} />
                </a>
              </div>
              <div className="rounded-3xl shadow-md overflow-hidden lg:ml-6">
                <div className="outline-none p-2 md:p-3">
                  {
                    !loaded && (
                      <img
                        src={bannerBlur}
                        className="rounded-3xl w-full"
                        alt="Toufiq Hasan Kiron"
                      />
                    )
                  }
                  <img
                    src={banner}
                    className="rounded-3xl w-full"
                    alt="Toufiq Hasan Kiron"
                    onLoad={() => {
                      setLoaded(true);
                    }
                    }
                    style={{ display: loaded ? 'block' : 'none' }}
                  />
                </div>
              </div>
            </div>
          </Fade>
          <Fade bottom distance="30px">
            <div className="flex justify-center items-center gap-8 md:w-2/3 lg:w-1/2 pt-5 md:pt-10 lg:pt-0 leading-loose">
              <div className='hidden lg:flex flex-col justify-start items-start gap-4'>
                <a href='https://www.facebook.com/toufiqhasankiron' target='_blank' rel="noreferrer" className={`border cursor-pointer py-4 px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                  <BiLogoFacebook size={20} />
                </a>
                <a href='https://www.linkedin.com/in/toufiq-hasan-kiron' target='_blank' rel="noreferrer" className={`border cursor-pointer py-4 px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                  <BiLogoLinkedin size={20} />
                </a>
                <a href='https://www.github.com/kiron0' target='_blank' rel="noreferrer" className={`border cursor-pointer py-4 px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                  <FiGithub size={20} />
                </a>
                <a href='https://www.buymeacoffee.com/_thk' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl group ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary bg-warning border-warning glass'} duration-500`}>
                  <SiBuymeacoffee className={`text-md md:text-xl duration-500 ${theme ? 'group-hover:text-white' : 'text-black group-hover:text-white'}`} />
                </a>
              </div>

              <div>
                <small className="text-sm">
                  WELCOME TO MY WORLD.
                </small>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight">
                  Hi, I’m <span className={`${theme ? 'text-warning' : 'text-primary'}`} title='Toufiq Hasan Kiron'>Toufiq Hasan Kiron</span>
                </h1>
                <h2 className="flex items-center gap-2 text-lg md:text-xl lg:text-2xl font-semibold leading-tight mt-3">
                  <span className={`${theme ? 'text-warning' : 'text-primary'}`}>a</span>
                  <Typewriter options={typewriterOptions} />
                </h2>
                <p className="py-4 mt-3 md:mt-5">
                  Aspiring Full-stack Dev, obsessed with code, coffee and travel. My life goal: Creating an app that books you a one-way flight to code paradise, where bugs are extinct and WiFi flows like water!
                </p>
                <div className='flex justify-start items-center md:pt-5'>
                  <Link to='contact' smooth={true} duration={1000} className={`font-semibold flex items-center gap-2 cursor-pointer py-2 md:py-3 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                    Say Hello <PiHandWavingBold size={20} />
                  </Link>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  )
}
